import gql from "@/api/gql.js"
import { query, mutation } from "./queries.js"
import resolveApiErrors from "@/api/resolveApiErrors"

export default {
	async inviteInternal(variables) {
		const res = await gql({
			query: mutation.inviteInternal,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithoutStatus",
			res,
			resKey: "inviteInternal"
		})
	},

	async updateInternal(variables) {
		const res = await gql({
			query: mutation.updateInternal,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateInternal"
		})
	},

	async assignRole(variables) {
		const res = await gql({
			query: mutation.assignRole,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addToPermissionGroup"
		})
	},

	async internals(variables) {
		const res = await gql({
			query: query.internals,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "internals"
		})
	},

	async internal(variables) {
		const res = await gql({
			query: query.internal,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithList",
			res,
			resKey: "internals"
		})
	},

	async createInternal(variables) {
		const res = await gql({
			query: mutation.createInternal,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "createInternal"
		})
	},

	async permissionGroups(variables) {
		const res = await gql({
			query: query.permissionGroups,
			variables
		})

		return resolveApiErrors({
			resolutionType: "queryWithoutList",
			res,
			resKey: "permissionGroups"
		})
	},

	async addContact(variables) {
		const res = await gql({
			query: mutation.addContact,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "addContact"
		})
	},

	async updateContact(variables) {
		const res = await gql({
			query: mutation.updateContact,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "updateContact"
		})
	},

	async deleteInternal(variables) {
		const res = await gql({
			query: mutation.deleteInternal,
			variables
		})

		return resolveApiErrors({
			resolutionType: "mutationWithStatus",
			res,
			resKey: "result"
		})
	}
}
